import { Button } from '@mui/material';
import { useState } from 'react';
import GameFormatWizardDialog, { buildDefaults } from './gameFormatWizardDialog';

const OVERRIDE_IGNORED_FIELDS = ['id', 'name', 'description', 'workspaceId', 'createdByUserId'];

// Determine which fields differ from the base (shared) format so the caller
// can highlight the overridden values.
const getOverriddenFields = (baseGameFormat, data) => {
  const baseline = buildDefaults(baseGameFormat || {});
  return Object.keys(data).filter(
    (key) => !OVERRIDE_IGNORED_FIELDS.includes(key) && data[key] !== baseline[key]
  );
};

const OverrideGameFormat = ({ gameFormat, baseGameFormat, onChange }) => {
  const [open, setOpen] = useState(false);

  const handleSave = async (data) => {
    onChange({
      ...gameFormat,
      ...data,
      overriddenFields: getOverriddenFields(baseGameFormat || gameFormat, data)
    });
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        color="blue"
        sx={{ mt: 1, width: '250px' }}
        onClick={() => setOpen(true)}>
        Change Format Values
      </Button>

      <GameFormatWizardDialog
        open={open}
        onClose={() => setOpen(false)}
        initialValues={gameFormat}
        onSave={handleSave}
        includeName={false}
        title="Override Game Format Settings"
        saveLabel="Apply Override"
      />
    </>
  );
};

export default OverrideGameFormat;
